// this is used instead of the Genesis WorkflowStateEnum since we have different values for RS 
export enum RightShipWorkflowStateEnum {
	PendingFormInput = 1,
	PendingTerminalRsReview = 2,
	Accepted = 3,
	Unacceptable = 4,
	Cancelled = 5,
	RequestingInfo = 6,
	AcceptableDayOnly = 1000,
	Completed = 1001
}